import type {ActionWorkflowDefinition} from "./workflowModels";

const WORKFLOW_MODIFY_URL = "/api/CoachAssistant/workflow/modify";

export interface WorkflowFieldUpdate {
    id: string;
    label: string;
    newValue: string;
}

export interface PlanModifyResponse {
    assistantMessage: string;
    fieldUpdates: WorkflowFieldUpdate[];
    updatedWorkflow: ActionWorkflowDefinition;
}

interface WorkflowConversationMessage {
    role: "user" | "assistant";
    content: string;
}

export async function modifyWorkflow(params: {
    userMessage: string;
    workflow: ActionWorkflowDefinition;
    conversationHistory?: WorkflowConversationMessage[];
    businessUnitId: string;
    sessionState?: Record<string, unknown>;
    signal?: AbortSignal;
}): Promise<PlanModifyResponse> {
    const response = await fetch(WORKFLOW_MODIFY_URL, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            userMessage: params.userMessage,
            workflow: params.workflow,
            conversationHistory: params.conversationHistory ?? [],
            context: {currentSelectedBusinessUnitId: params.businessUnitId},
            sessionState: params.sessionState ?? {}
        }),
        signal: params.signal
    });

    if (!response.ok) {
        const errorText = await response.text();
        let message = errorText || `Workflow modify failed with status ${response.status}`;
        try {
            const parsed = JSON.parse(errorText) as {
                detail?: string | Array<{msg?: string}>;
            };
            if (typeof parsed.detail === "string") {
                message = parsed.detail;
            } else if (Array.isArray(parsed.detail)) {
                message = parsed.detail
                    .map((item) => item.msg)
                    .filter(Boolean)
                    .join("; ");
            }
        } catch {
            // Keep raw error text when response is not JSON.
        }
        throw new Error(message);
    }

    return (await response.json()) as PlanModifyResponse;
}
